import React, { useContext, useState } from "react";
import { Layout, Typography, Button, Drawer, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { GlobalOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../context/themeContext";
import { THEME_COLORS } from "../../themeConfig";
import { PRIME_MEDICAL_LOGO_URL } from "../../constants/common";
import { ROUTES } from "../../constants/Route";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
];

const CustomHeader = () => {
  const { Header } = Layout;
  const { Title } = Typography;
  const { theme } = useContext(ThemeContext);
  const themeColors = THEME_COLORS[theme] || THEME_COLORS.primary;
  const isPrimeMedicalTheme = theme === "primemedicaltheme";

  const { t, i18n } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.xl;
  const [open, setOpen] = useState(false);

  const LanguageButtons = ({ onClick, isMobile }) => {
    const selectedLang = i18n.language;

    const getButtonProps = (lang) => {
      const isSelected = selectedLang === lang;

      return {
        type: isMobile
          ? isSelected
            ? "primary"
            : "default"
          : "default",
        style: isMobile ? {} : getLangButtonStyle(lang),
      };
    };

    return (
      <div className={`flex gap-2 ${isMobile ? "flex-col" : "flex-row"}`}>
        {LANGUAGES.map(({ code, label }) => (
          <Button
            key={code}
            {...getButtonProps(code)}
            onClick={() => {
              i18n.changeLanguage(code);
              onClick?.();
            }}
            className={`lang-btn ${theme}`}
            block
          >
            {label}
          </Button>
        ))}
      </div>
    );
  };

  // Keep original purple for primary/secondary; blue only for PrimeMedicalTheme
  const selectedLangBg = isPrimeMedicalTheme
    ? themeColors.headerBg
    : "#9747ff";

  const getLangButtonStyle = (lang) => ({
    backgroundColor: i18n.language === lang ? selectedLangBg : "transparent",
    borderColor: i18n.language === lang ? selectedLangBg : "#fff",
    color: "#fff",
  });

  return (
    <Header
      className={`top-header${isPrimeMedicalTheme ? " top-header--prime-medical" : ""}`}
      style={{ position: "relative" }}
    >
      {isPrimeMedicalTheme && (
        <Link to={ROUTES.HOME} className="header-client-logo" aria-label="Go to home">
          <img
            src={window.location.origin + PRIME_MEDICAL_LOGO_URL}
            alt="Prime Medical"
          />
        </Link>
      )}

      <Title level={2} className="title">
        {t("common:header_title")}
      </Title>

      <div
        style={{
          position: "absolute",
          right: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {/* Globe Icon */}
        <div className="flex items-center justify-center mr-0 md:mr-2 cursor-pointer">
          <GlobalOutlined
            onClick={() => isMobile && setOpen(true)}
            style={{ fontSize: "1.5rem", color: "#fff" }}
          />
        </div>

        {/* Desktop only */}
        {!isMobile && (
          <div className="flex gap-2">
            <LanguageButtons isMobile={false} />
          </div>
        )}
      </div>
      <Drawer
        title="Select Language"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
        width={230}
        bodyStyle={{ padding: "16px" }}
      >
        <LanguageButtons onClick={() => setOpen(false)} isMobile={true} />
      </Drawer>
    </Header>
  );
};

export default CustomHeader;
